import { CardTemplateProps } from 'medere-ui-framework'
import { useMemo } from 'react'
import { HealthEntityListItemDTO } from '../../../dto/HealthEntityListItemDTO'
import HealthEntityActionMenu, { HealthEntityActionMenuItem } from './HealthEntityActionMenu'

export interface HealthEntityCardActionsProps {
  onView: (item: HealthEntityListItemDTO) => void
  onEdit: (item: HealthEntityListItemDTO) => void
  onDelete: (item: HealthEntityListItemDTO) => void
}

type HealthEntityListCardProps = CardTemplateProps & HealthEntityCardActionsProps & {
  entity: HealthEntityListItemDTO
}

function normalizeCardValue(value: string | null | undefined, emptyText = 'Sin datos') {
  const normalizedValue = String(value ?? '').trim()
  return normalizedValue !== '' ? normalizedValue : emptyText
}

export default function HealthEntityListCard({
  entity,
  onView,
  onEdit,
  onDelete,
}: Readonly<HealthEntityListCardProps>) {
  const cardMenuItems: HealthEntityActionMenuItem[] = useMemo(() => [
    {
      label: 'Ver detalle',
      icon: 'pi pi-eye',
      action: () => onView(entity),
    },
    {
      label: 'Editar',
      icon: 'pi pi-file-edit',
      action: () => onEdit(entity),
    },
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      action: () => onDelete(entity),
    },
  ], [entity, onDelete, onEdit, onView])

  const title = normalizeCardValue(entity.commercialname, 'Sin nombre comercial')
  const businessName = normalizeCardValue(entity.businessname)
  const typeLabel = normalizeCardValue(entity.typelabel)
  const statusLabel = entity.active ? 'Activo' : 'Inactivo'

  return (
    <article className='health-entity-mobile-card'>
      <div className='health-entity-mobile-card-header'>
        <h3 className='health-entity-mobile-card-title'>{title}</h3>
        <HealthEntityActionMenu
          menuItems={cardMenuItems}
          buttonClassName='p-button-text health-entity-mobile-card-menu-btn'
          buttonAriaLabel='Opciones de la obra social'
        />
      </div>

      <div className='health-entity-mobile-card-body'>
        <div className='health-entity-mobile-card-row'>
          <span className='health-entity-mobile-card-key'>Razón social</span>
          <span className='health-entity-mobile-card-value'>{businessName}</span>
        </div>
        <div className='health-entity-mobile-card-row'>
          <span className='health-entity-mobile-card-key'>Tipo</span>
          <span className='health-entity-mobile-card-value'>{typeLabel}</span>
        </div>
        <div className='health-entity-mobile-card-row'>
          <span className='health-entity-mobile-card-key'>Estado</span>
          <span className='health-entity-mobile-card-value'>{statusLabel}</span>
        </div>
      </div>
    </article>
  )
}
